export function sanitizePhoneInput(value) {
  if (value == null || value === '') return '';
  return String(value).replace(/[^\d+]/g, '');
}

export function formatMpesaPhoneNumber(phone) {
  if (phone == null || phone === '') return '';
  let cleaned = String(phone).replace(/\D/g, '');
  if (!cleaned) return '';
  if (cleaned.startsWith('0')) {
    cleaned = '254' + cleaned.substring(1);
  } else if (!cleaned.startsWith('254')) {
    if (cleaned.length === 9 && cleaned.startsWith('7')) {
      cleaned = '254' + cleaned;
    }
  }
  return cleaned;
}

export function validateSafaricomPhone(phone) {
  const formatted = formatMpesaPhoneNumber(phone);
  return formatted.length === 12 && formatted.startsWith('2547');
}

/** Human-friendly Kenyan display while typing (07… or +254 7…). */
export function formatKenyanPhoneDisplay(phone) {
  const raw = sanitizePhoneInput(phone);
  if (!raw) return '';

  let digits = raw.replace(/\D/g, '');
  if (raw.startsWith('+') && digits.startsWith('254')) {
    digits = digits.slice(3);
  } else if (digits.startsWith('254')) {
    digits = digits.slice(3);
  } else if (digits.startsWith('0')) {
    digits = digits.slice(1);
  }

  digits = digits.slice(0, 9);
  if (!digits) return raw.startsWith('+') ? '+254 ' : '';

  const parts = [];
  if (digits.length <= 3) parts.push(digits);
  else if (digits.length <= 6) parts.push(digits.slice(0, 3), digits.slice(3));
  else parts.push(digits.slice(0, 3), digits.slice(3, 6), digits.slice(6));

  const spaced = parts.join(' ');
  return raw.startsWith('+') || raw.startsWith('254') ? `+254 ${spaced}` : `0${spaced}`;
}

export function mpesaPhoneValidationMessage(phone) {
  const cleaned = sanitizePhoneInput(phone);
  if (!cleaned) return 'Enter your Safaricom M-Pesa number.';
  if (!validateSafaricomPhone(cleaned)) {
    return 'Use a valid Safaricom number (e.g. 0712 345 678 or +254 712 345 678).';
  }
  return null;
}
